import { Injectable } from '@angular/core';
import { ApiServerService } from '@common/api-server/api-server';
import { TranslateService } from '@ngx-translate/core';
import { ProjectDbService } from '@shared/database/project-db-service';
import { DiscountRateModel } from '@shared/models/setting.model';
import { AppService } from 'projects/admin/src/app/core/services/app.service';
import { combineLatest, filter, firstValueFrom, map, of, shareReplay, switchMap, tap } from 'rxjs';
import { pv } from '../helpers/pv';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  discountRates:DiscountRateModel;
  constructor(
    private projectDbService: ProjectDbService,
    private appService:AppService,
    private aSS: ApiServerService,
    private translateService: TranslateService,
    ) {
    this.appService.discountRates$.subscribe(discountRates=>
      this.discountRates = discountRates)
  }

  allProjects$ = this.projectDbService.getAll$().pipe(shareReplay(1));
  userProjects$ = combineLatest([this.allProjects$, this.appService.userProfile$]).pipe(
    filter(([projects, user])=>!!user),
    map(([projects, user])=>{
      return projects.filter(project=> !user.projects || !user.projects.length ||  user.projects.find(p=>p.id === project.id))
    })
  )
  project$ = (id) => (id ? this.projectDbService.get$(id): of(null)).pipe(
    // tap(console.log),
    shareReplay(1),
    tap(project=>this.appService.activeProject$.next(project)),
  );


  create(data, isNew = false) {
    return this.projectDbService.upsert(data, isNew);
  }

  update(data){
    return this.projectDbService.upsert(data);
  }

  async delete(project){
    const ret = await new Promise (resolve => {
      this.appService.confirmationService.confirm({
        header: this.translateService.instant('LABEL.PLEASE_CONFIRM'),
        message: this.translateService.instant('LABEL.DELETE_RECONFIRM'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => resolve(true),
        reject: () => resolve(false)
      });
    })
    //TODO Se deberian eliminar todos los datos de los ejercicios relacionados al proyecto
    //     Sin embargo por ahora quedaran y así se podrá recuperar algún proyecto en caso de error
    return ret ? this.projectDbService.delete(project.id) : of(false);

  }

  evalPV60(value){
    const discountType = this.appService.activeProject.discountType;
    const t0 = this.discountRates.discountRate30.find(discountRate => discountRate.type == discountType ).value;
    const t30 = this.discountRates.discountRate75.find(discountRate => discountRate.type == discountType ).value;
    const res = pv(60, value, t0, t30 );
    // console.log({discountType,discountRates:this.discountRates,  t0, t30});
    return res;
  }

  async changeDiscounType(data: { project: any;  discountType:DiscountRateModel.DiscountType}):Promise<any>{
    const {project, discountType} = data;
    const projectId = project.id;
    try {
      return await firstValueFrom(this.aSS.call(`api/projects/updatePv60`, {discountType, projectId}));
    } catch (error) {
      console.error(error);
      return null;
    }
  }
}
